<!--
    This component encapsulates a conditional message displayed in red or green text.

    For red text, set the errorMessage property. For green, set successMessage.

    Setting either message will wipe out the other; you can't have both failure and success.

    Note, the message is rendered as HTML. This means that tags like <br /> can
        be used, but also means that special characters may need to be escaped.
-->

<template>
    <div class="form-result-message" v-if="hasMessage" v-bind:class="{failure:error, success:!error}">
        <span v-html="message"></span>
    </div>
</template>

<script>
    export default {
        name: 'form-result-message',
        props: {
            message: {
                // The message displayed the to user
                type: String,
            },
            error: {
                // If true, the message will be red. If false, it will be green.
                type: Boolean,
            }
        },
        computed: {
            hasMessage() {
                return !!this.message;
            }
        }
    };
</script>

<style scoped lang="scss">
    .form-result-message {
        border-radius: 3px;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        padding: 5px;
        text-align: center;
        text-transform: uppercase;
    }

    .form-result-message.failure {
        /* Note that #d34428 == rgb(211, 68, 40) */
        background-color: rgba(211, 68, 40, 0.102);
        color: #d34428;
    }

    .form-result-message.success {
        /* Note that #088354 == rgb(2, 131, 84) */
        background-color: rgba(2, 131, 84, 0.102);
        color: #088354;
    }
</style>